import wcBear from '../assets/images/wc.svg';

export function Logo() {
  return (
    <div className="flex items-center gap-[1px]">
      <img src={wcBear} alt="" className="h-10 w-10" />
      <span className="block text-xl font-bold text-foreground leading-none mt-1">
        WealthyCub
      </span>
    </div>
  );
}
